import { Box, Divider, IconButton, InputLabel, Typography, styled } from '@mui/material';
import InputController, { InputControllerWithIcon } from '../../../components/InputController/InputController';
import React, { useRef } from 'react'
import { format, parseISO } from 'date-fns';

import ColorBlindTest from './sub-form-sections/ColorBlindTest';
import DRGrading from './sub-form-sections/DRGrading';
import DatePickerController from '../../../components/CustomDatepicker/CustomDatePicker';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import FocusedHistory from './sub-form-sections/FocusedHistory';
import DiabteticPdf from "../../../components/Diabtetic_Pdf/DiabeticFormPdf"
import IdentifyingSection from './sub-form-sections/IdentifyingSection';
import KnownPatients from './sub-form-sections/KnownPatients';
import PresentingComplaintSection from './sub-form-sections/PresentingComplaintSection'
import PrintIcon from '@mui/icons-material/Print';
import RadioButtonController from '../../../components/RadioButtonController/RadioButtonController';
import ReactToPrint from 'react-to-print';
import SummaryDiabetic from './sub-form-sections/SummaryDiabetic';
import VisualAcuityTest from './sub-form-sections/VisualAcuityTest';
import dayjs from 'dayjs';
import { facilityType } from './sub-form-sections/formOptions';
import { useForm } from 'react-hook-form';

export const ParentContainerSection = ({heading=false, children})=>{
  return (
    <>
      <Box sx={{ border: "1px solid", borderColor: "#DDDDDD", display: "flex", flexDirection: "column", gap: "1rem", borderRadius: "10px", mb: "0.5rem" }}>
        {heading && <Box sx={{ backgroundColor: "#F5F5F5", p: "0.5rem", borderRadius: "inherit" }}>
          <Typography variant="h6" sx={{ position: "relative", left: "10px", fontWeight: "bold" }}>{heading}</Typography>
        </Box>}
        <Box sx={{ width: "95%", margin: "0 auto",  }}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export const CustomInputLable = styled(InputLabel)(({theme})=>({
  fontSize: "14px",
  textWrap: "wrap",
  fontWeight: "bold",
  color: "black",
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },
}));

export const InputContainer = styled(Box)(({theme, width, fitcontent, minWidth})=>({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  width: "100%",
  gap: "1rem",
  "& > label:first-of-type": {
    // maxWidth: minWidth ? minWidth : undefined,
    width: width ? width : fitcontent ? fitcontent : "20%",
  },
  [theme.breakpoints.down("lg")]:{
    "& > label:first-of-type": {
      //  maxWidth: minWidth ? minWidth : undefined,
      width:width ? width : fitcontent ? fitcontent : "15%",
    },
  },
  [theme.breakpoints.down("md")]:{
    flexDirection: "column",
    gap: "0.35rem",
    "& > label:first-of-type": {
      width: "100%",
    },
    "& > div:first-of-type": {
      width: "100%",
    },
  },

  marginBottom: "1rem"

}));

const DiabeticForm = ({formData}) => {
    const componentRef = useRef();

    const { handleSubmit, setValue, watch, getValues, reset, control, formState: { errors } } = useForm({
        defaultValues:{
          facility_name: formData?.facility_name || "",
      facility_type: formData?.facility_type || "",
      facility_date: formData?.form_filling_Date || "",

      patient_name: formData?.patient_name || "",
      patient_dob: formData?.patient_DOB || "",
      patient_gender: formData?.patient_gender || "",
      cmis_number: formData?.patient_cmis_id || "",

      presenting_complaint: formData?.presenting_complaint || "",

      redness: {
        left: formData?.presenting_complaint_left_redness || [],
        right: formData?.presenting_complaint_right_redness || []
      },

      visionLoss: {
        left: formData?.presenting_complaint_left_visionLoss || [],
        right: formData?.presenting_complaint_right_visionLoss || []
      },

      pain: {
        left: formData?.presenting_complaint_left_pain || [],
        right: formData?.presenting_complaint_right_pain || []
      },

      eyeInjury: {
        left: formData?.presenting_complaint_left_eyeInjury || [],
        right: formData?.presenting_complaint_right_eyeInjury || []
      },

      visualDisturbances: {
        left: formData?.presenting_complaint_left_visualDisturbances || [],
        right: formData?.presenting_complaint_right_visualDisturbances || []
      },

      otherComplaints: formData?.presenting_complaint_otherComplaints || "",

      reviewSystem: formData?.presenting_complaint_reviewSystem || [],

      focused_past_ocular_history: formData?.focused_past_ocular_history || "", // newly added check UI
      focused_past_ocular_history_comment: formData?.focused_past_ocular_history_comment || "", // newly added check UI

      pasthistory_comborbidity: formData?.pasthistory_comborbidity || [],
      on_treatment: formData?.on_treatment || "",
      treatment_type: formData?.treatment_type || [],

      treatment_years: formData?.treatment_years || "",
      date_of_diagnosis:formData?.date_of_diagnosis || "",
      type_of_diagnosis: formData?.type_of_diagnosis || "",
      current_medication: formData?.current_medication || "",
      medication_oral_injection: formData?.medication_oral_injection || [],
      blood_sugar_level: {
        RBS: formData?.blood_sugar_level?.RBS || "",
        FBS: formData?.blood_sugar_level?.FBS || "",
        HbA1c: formData?.blood_sugar_level?.HbA1c || ""
      },
      blood_sugar_levels: formData?.blood_sugar_levels || "",

      risk_factor_excercise: formData?.risk_factor_excercise || "",
      alochol_use: formData?.alochol_use || "",
      diet: formData?.diet || "",
      smoker: formData?.smoker || "",

      risk_rating: formData?.form_risk_rating || "",
      diabetic_comments: formData?.diabetic_comments || "",

      color_blindness_left: formData?.color_blindness_left || "",
      color_blindness_right: formData?.color_blindness_right || "",

      visual_acuity_left: formData?.visual_acuity_left || "",
      visual_acuity_right: formData?.visual_acuity_right || "",

      dr_retinopathy_left: formData?.dr_retinopathy_left || "",
      dr_retinopathy_right: formData?.dr_retinopathy_right || "",

      image1: formData?.image1 || "",
      image2: formData?.image2 || "",
      image3: formData?.image3 || "",
      image4: formData?.image4 || "",

      clinic_name: formData?.hospital_Name || "",
      referral_site_name: formData?.hospital_Name || "",


        }
    });

    const onSubmit = async(data)=>{
        console.log("dataValue", data)
    }

    const handleDateChange = (date) => {
        console.log(date);
      };

  return (
    <>
       <div>
      <ReactToPrint
        trigger={() => <IconButton sx={{
            borderRadius: "2%", ":hover": {
              background: (theme) => theme.palette.secondary.main,
              borderRadius: "2%"
            }
          }}><strong>Print form</strong><PrintIcon />
          </IconButton>}
        content={() => componentRef.current}
      />
      <div style={{ display: "none" }}>
        <DiabteticPdf ref={componentRef} formData={formData}/>
      </div>
    </div>

            <form onSubmit={handleSubmit(onSubmit)} style={{  padding: "1rem" }}>
            {formData?.form_accept_reject && <Typography variant='h1' color="error" sx={{fontWeight:"bold", textAlign: "center"}}>This form has been rejected by the referred hospital</Typography>}
                    <Box sx={{  display:"flex", justifyContent:"center", flexDirection: "column", gap:"1rem", alignItems:"center", my:2, }}>
                              <Box sx={{ display: "flex", gap: "0.5rem" }}>
                              <InputControllerWithIcon
                                    name="facility_name"
                                    label="Facility Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />   
                             {/*TODO: NURSE NAME TO BE ADDED */}
                                  {/* <InputControllerWithIcon
                                    name="nurse_name"
                                    label="Nurse Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />   */}
                            </Box>

                            <Box sx={{ display: "flex", gap:"1rem", alignItems: "center", flexWrap: "wrap"}}> 
                            <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold"}}>Facility Type :</InputLabel>
                            <RadioButtonController
                                name="facility_type"
                                label="Facility Type"
                                control={control}
                                errors={errors}
                                options={facilityType}
                                isRow={true}
                                isDisabled={true}
                            />     
                            <DatePickerController name="facility_date"
                             label="Test Date"
                              control={control}
                               errors={errors}
                                readOnly={true}
                                onChange={handleDateChange}
                                getValues={getValues}
                                defaultheight={false}
                                 />
                            </Box>
                </Box>  
                <Divider/>
                <Box >
                <IdentifyingSection control={control} errors={errors}/>
                  <PresentingComplaintSection control={control} errors={errors} getValues={getValues} setValue={setValue} watch={watch}/>
                  <FocusedHistory  control={control} errors={errors} getValues={getValues} setValue={setValue} watch={watch}/>
                  <KnownPatients control={control} errors={errors} getValues={getValues} watch={watch}/>
                  </Box>   

                  <ColorBlindTest control={control} errors={errors} getValues={getValues} />
                  <VisualAcuityTest control={control} errors={errors} getValues={getValues} />
                  <DRGrading control={control} errors={errors} getValues={getValues} />
                  <SummaryDiabetic control={control} errors={errors} getValues={getValues} />

                 {/* <Box sx={{ display: "flex", justifyContent: "space-between", width:"100%", gap:"2rem", my:2}}>
                    <Box sx={{ flex: "1 1 50%"}}>
                      <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold", my:2}}>Clinic Name</InputLabel>
                        <InputController
                            name="clinic_name"
                            label="Clinic Name"
                            control={control}
                            errors={errors}
                            getValues={getValues}
                            size="small"
                            isDisabled={true}
                         />
                      </Box> 
                 </Box> */}

                 <Box sx={{ display: "flex", justifyContent: "space-between", width:"100%", gap:"2rem", my:2}}>
                      <Box sx={{ flex: "1 1 50%"}}>
                      <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold", my:2}}>Referred Tertiary Healthcare Facility Name</InputLabel>
                        <InputController
                            name="referral_site_name"
                            label="Referred Tertiary Healthcare Facility Name"
                            control={control}
                            errors={errors}
                            getValues={getValues}
                            size="small"
                            isDisabled={true}
                         />
                      </Box> 
                 </Box>
            </form>
    </>
  )
}

export default DiabeticForm